(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__svFooterInit) return;
    window.__svFooterInit = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sv-top]');
      if (!b) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var opts = { top: 0, behavior: reduce ? 'auto' : 'smooth' };
      var w = document.querySelector('.page-wrapper');
      // o scroller efetivo no desktop pode ser .page-wrapper
      if (w && w.scrollHeight > w.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(w).overflowY)) w.scrollTo(opts);
      window.scrollTo(opts);
      var skip = document.querySelector('a[href="#MainContent"], main, #MainContent');
      if (skip && skip.focus) { skip.setAttribute('tabindex', '-1'); skip.focus({ preventScroll: true }); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (function () {
    if (window.__svGuideInit) return;
    window.__svGuideInit = true;

    function scroller() {
      var w = document.querySelector('.page-wrapper');
      if (w && w.scrollHeight > w.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(w).overflowY)) return w;
      return null;
    }
    function progress() {
      var bar = document.querySelector('[data-sv-prog]');
      var art = document.getElementById('sv-art-content');
      if (!bar || !art) return;
      var r = art.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = (vh - r.top) / (r.height + vh * 0.2);
      p = Math.max(0, Math.min(1, p));
      bar.firstElementChild.style.transform = 'scaleX(' + p + ')';
    }
    function tocState() {
      var d = document.querySelector('[data-sv-toc]');
      if (!d) return;
      d.open = window.matchMedia('(min-width: 1100px)').matches;
      d.dataset.svReady = '1';
    }
    function tocActive() {
      var links = document.querySelectorAll('.sv-art-toc a');
      if (!links.length) return;
      var cur = null;
      links.forEach(function (a) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (t && t.getBoundingClientRect().top < window.innerHeight * 0.3) cur = a;
      });
      links.forEach(function (a) { a.classList.toggle('is-on', a === cur); });
    }
    function tick() { progress(); tocActive(); }

    var months = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
    document.addEventListener('input', function (e) {
      var inp = e.target.closest && e.target.closest('[data-sv-calc-in]');
      if (!inp) return;
      var box = inp.closest('[data-sv-calc]');
      var out = box.querySelector('[data-sv-calc-out]');
      var dmin = parseInt(box.getAttribute('data-days-min'), 10) || 5;
      var dmax = parseInt(box.getAttribute('data-days-max'), 10) || 12;
      if (!inp.value) return;
      var p = inp.value.split('-');
      var d = new Date(+p[0], +p[1] - 1, +p[2]);
      if (isNaN(d.getTime())) return;
      /* prazo: fonte única SV.ship (5 a 12 dias úteis, da compra à entrega) */
      var limit = null;
      if (window.SV && SV.ship) limit = SV.ship.latestOrder(d);
      else {
        var c = new Date(d.getTime()), n = dmax;
        while (n > 0) { c.setDate(c.getDate() - 1); if (c.getDay() !== 0 && c.getDay() !== 6) n--; }
        var t0 = new Date(); t0.setHours(0, 0, 0, 0);
        limit = c < t0 ? null : c;
      }
      out.textContent = limit ? 'Peça até ' + limit.getDate() + ' de ' + months[limit.getMonth()] + ' de ' + limit.getFullYear() : 'Para essa data, o prazo máximo já não alcança';
      var small = document.createElement('small');
      small.textContent = limit
        ? 'A entrega leva de ' + dmin + ' a ' + dmax + ' dias úteis, da compra à entrega. A data considera o prazo máximo.'
        : 'A entrega leva de ' + dmin + ' a ' + dmax + ' dias úteis. Se a data não pode falhar, fale com a gente antes de comprar.';
      out.appendChild(small);
    });

    function init() { tocState(); tick(); }
    document.addEventListener('scroll', tick, { passive: true, capture: true });
    window.addEventListener('resize', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-measures-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__svMeasuresInit) return;
    window.__svMeasuresInit = true;

    var CAMPOS = [['altura', 'Altura', 130, 200], ['busto', 'Busto', 70, 150], ['cintura', 'Cintura', 55, 140], ['quadril', 'Quadril', 75, 160]];
    var PREF = { justo: 'Justa', certo: 'Na medida', solto: 'Solta' };

    function load() {
      try {
        var o = window.SV && SV.fit && SV.fit.get ? SV.fit.get() : (window.SV && SV.store ? SV.store.get('medidas', null) : JSON.parse(localStorage.getItem('sv:medidas') || 'null'));
        return o && typeof o === 'object' && +o.altura > 0 ? o : null;
      } catch (e) { return null; }
    }
    function save(o) {
      try {
        if (window.SV && SV.fit && SV.fit.set) { o ? SV.fit.set(o) : SV.fit.clear(); }
        else if (window.SV && SV.store) { o ? SV.store.set('medidas', o) : SV.store.remove('medidas'); }
        else { o ? localStorage.setItem('sv:medidas', JSON.stringify(o)) : localStorage.removeItem('sv:medidas'); }
      } catch (e) {}
    }
    function validar(o) {
      for (var i = 0; i < CAMPOS.length; i++) {
        var c = CAMPOS[i], v = o[c[0]];
        if (v == null || v === '') continue;
        if (!(+v >= c[2] && +v <= c[3])) return c[1] + ': informe entre ' + c[2] + ' e ' + c[3] + ' cm.';
      }
      if (!(+o.altura > 0)) return 'Informe a sua altura: é por ela que calculamos onde a barra cai.';
      if (!(+o.busto > 0) && !(+o.cintura > 0) && !(+o.quadril > 0)) return 'Informe ao menos o busto, a cintura ou o quadril.';
      return '';
    }
    function range(s) {
      var m = String(s).match(/(\d+(?:[.,]\d+)?)\s*(?:–|-|a)\s*(\d+(?:[.,]\d+)?)/);
      if (m) return [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))];
      var n = parseFloat(String(s).replace(',', '.'));
      return isNaN(n) ? null : [n, n];
    }
    function pick(root, prof) {
      var rows = [].slice.call(root.querySelectorAll('[data-sv-gt] tbody tr'));
      if (!rows.length) return null;
      var best = -1, why = [];
      ['busto', 'cintura', 'quadril'].forEach(function (k) {
        var v = +prof[k]; if (!(v > 0)) return;
        var idx = rows.length - 1;
        for (var i = 0; i < rows.length; i++) {
          var r = range(rows[i].getAttribute('data-' + k)); if (!r) continue;
          if (v <= r[1]) { idx = i; break; }
        }
        why.push([k, idx]);
        if (idx > best) best = idx;
      });
      if (best < 0) return null;
      return { row: rows[best], size: rows[best].getAttribute('data-size'), why: why, rows: rows };
    }
    function mark(root, row) {
      root.querySelectorAll('[data-sv-gt] tbody tr').forEach(function (r) { r.classList.toggle('is-me', r === row); });
    }
    function cm(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }

    function render(root) {
      var prof = load();
      var me = root.querySelector('[data-sv-me]');
      var res = root.querySelector('[data-sv-res]');
      var cpy = root.querySelector('[data-sv-copy-box]');
      if (!me) return;
      if (!prof) {
        me.setAttribute('data-state', 'form');
        res.hidden = true; if (cpy) cpy.hidden = true;
        mark(root, null);
        var alt = root.querySelector('[data-sv-comp]'); if (alt) hem(root, +root.querySelector('#sv-md-alt').value);
        return;
      }
      me.setAttribute('data-state', 'resumo');
      var sum = me.querySelector('[data-sv-sum]');
      var html = '';
      CAMPOS.forEach(function (c) { if (+prof[c[0]] > 0) html += '<div><dt>' + c[1] + '</dt><dd>' + prof[c[0]] + '<small>cm</small></dd></div>'; });
      html += '<div class="is-w"><dt>Caimento</dt><dd>' + (PREF[prof.pref] || PREF.certo) + '</dd></div>';
      sum.innerHTML = html;
      if (cpy) cpy.hidden = false;
      var r = pick(root, prof);
      if (r) {
        res.hidden = false;
        res.querySelector('[data-sv-res-h]').textContent = 'Pela tabela geral, o seu tamanho é ' + r.size + '.';
        var names = { busto: 'busto', cintura: 'cintura', quadril: 'quadril' };
        var dec = r.why.filter(function (w) { return w[1] === r.rows.indexOf(r.row); }).map(function (w) { return names[w[0]]; });
        res.querySelector('[data-sv-res-p]').textContent = 'O tamanho é decidido por ' + dec.join(' e ') + '. Entre dois tamanhos, indicamos o maior. A tabela que vale é a da própria peça: abra o provador para ver.';
        mark(root, r.row);
      } else { res.hidden = true; mark(root, null); }
      var altInp = root.querySelector('#sv-md-alt');
      if (altInp && +prof.altura >= 145 && +prof.altura <= 190) { altInp.value = prof.altura; }
      if (altInp) hem(root, +altInp.value);
    }

    function hem(root, h) {
      var out = root.querySelector('#sv-md-alt-o'); if (out) out.textContent = h;
      var salto = +(root.querySelector('input[name="sv-salto"]:checked') || { value: 0 }).value;
      root.querySelectorAll('[data-sv-lens] tbody tr').forEach(function (tr) {
        var len = parseFloat(tr.getAttribute('data-len')); if (!(len > 0)) return;
        // ombro = 0,818 x altura (Drillis e Contini, 1966); barra = ombro - comprimento (+ salto). Estimativa.
        var d = 0.818 * h - len + salto;
        var cell = tr.querySelector('[data-sv-hem]');
        var v = Math.round(d);
        cell.textContent = v > 0 ? v + ' cm acima do chão' : (v === 0 ? 'rente ao chão' : Math.abs(v) + ' cm além do chão');
      });
    }

    document.addEventListener('submit', function (e) {
      var f = e.target.closest && e.target.closest('[data-sv-form]'); if (!f) return;
      e.preventDefault();
      var root = f.closest('[data-sv-measures]');
      var o = { pref: (f.querySelector('input[name="pref"]:checked') || { value: 'certo' }).value };
      CAMPOS.forEach(function (c) { var v = parseFloat(String(f.elements[c[0]].value).replace(',', '.')); if (v > 0) o[c[0]] = Math.round(v); });
      var msg = validar(o), err = f.querySelector('[data-sv-err]');
      err.textContent = msg;
      if (msg) { return; }
      save(o); render(root);
      var res = root.querySelector('[data-sv-res]');
      if (!res.hidden) { res.focus({ preventScroll: true }); res.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); }
    });

    document.addEventListener('click', function (e) {
      var t = e.target; if (!t.closest) return;
      var root = t.closest('[data-sv-measures]'); if (!root) return;
      if (t.closest('[data-sv-edit]')) {
        var prof = load() || {}, f = root.querySelector('[data-sv-form]');
        CAMPOS.forEach(function (c) { f.elements[c[0]].value = prof[c[0]] || ''; });
        var r = f.querySelector('input[name="pref"][value="' + (prof.pref || 'certo') + '"]'); if (r) r.checked = true;
        root.querySelector('[data-sv-me]').setAttribute('data-state', 'form');
        root.querySelector('[data-sv-cancel]').hidden = false;
        f.elements.altura.focus();
      } else if (t.closest('[data-sv-cancel]')) { render(root); }
      else if (t.closest('[data-sv-del]')) { save(null); render(root); }
      else if (t.closest('[data-sv-fit-open]')) { if (window.SV && SV.emit) SV.emit('fit:open'); }
      else if (t.closest('[data-sv-copy]')) {
        var p = load(); if (!p) return;
        var txt = 'Minhas medidas: altura ' + p.altura + ' cm' + (p.busto ? ', busto ' + p.busto : '') + (p.cintura ? ', cintura ' + p.cintura : '') + (p.quadril ? ', quadril ' + p.quadril : '') + ' (cm). Caimento: ' + (PREF[p.pref] || PREF.certo).toLowerCase() + '.';
        var s = root.querySelector('[data-sv-copy-s]');
        (navigator.clipboard ? navigator.clipboard.writeText(txt) : Promise.reject()).then(function () { s.textContent = 'Copiado. Cole onde quiser.'; }, function () { s.textContent = 'Não foi possível copiar.'; });
      }
    });

    document.addEventListener('input', function (e) {
      var t = e.target; if (!t.closest) return;
      var root = t.closest('[data-sv-measures]'); if (!root) return;
      if (t.matches('#sv-md-alt')) hem(root, +t.value);
      if (t.matches('[data-sv-ax],[data-sv-ob]')) {
        var box = t.closest('[data-sv-flat]'), out = box.querySelector('[data-sv-flat-out]');
        var ax = parseFloat(box.querySelector('[data-sv-ax]').value.replace(',', '.')), ob = parseFloat(box.querySelector('[data-sv-ob]').value.replace(',', '.'));
        var h = '';
        if (ax > 20 && ax < 90) h += '<p class="sv-md-calc__o">Busto da peça: <b>' + cm(ax * 2) + ' cm</b></p>';
        if (ob > 60 && ob < 220) h += '<p class="sv-md-calc__o">Comprimento: <b>' + cm(ob) + ' cm</b></p>';
        if (h) h += '<p class="sv-md-calc__s">A medição à mão varia de 1 a 3 cm. Compare com a coluna Busto da tabela da peça.</p>';
        out.innerHTML = h || '<p class="sv-md-calc__o">Coloque as medidas da sua peça.</p>';
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[name="sv-salto"]')) {
        var root = e.target.closest('[data-sv-measures]'); hem(root, +root.querySelector('#sv-md-alt').value);
      }
    });

    function init() { document.querySelectorAll('[data-sv-measures]').forEach(render); }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('sv:fit:change', init);
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-page-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__svShipCalcInit) return;
    window.__svShipCalcInit = true;
    var WD = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
    var MO = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
    function fmt(d) { return WD[d.getDay()] + ', ' + d.getDate() + ' de ' + MO[d.getMonth()]; }
    function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
    function parse(v) { if (!v) return null; var p = v.split('-'); var d = new Date(+p[0], +p[1] - 1, +p[2]); return isNaN(d.getTime()) ? null : d; }
    function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function addB(d, n) { var r = new Date(d.getTime()); while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; } return r; }
    /* prazo: fonte única SV.ship (assets/sv-core.js); o fallback usa os mesmos settings */
    function run(box) {
      var min = parseInt(box.getAttribute('data-days-min'), 10) || 5, max = parseInt(box.getAttribute('data-days-max'), 10) || 12;
      var S = window.SV && window.SV.ship;
      var oi = box.querySelector('[data-calc="order"]'), ei = box.querySelector('[data-calc="event"]'), out = box.querySelector('[data-calc="out"]');
      var t0 = new Date(); t0.setHours(0, 0, 0, 0);
      if (!oi.value) oi.value = iso(t0);
      oi.min = iso(t0);
      ei.min = iso(t0);
      var o = parse(oi.value) || t0;
      var w = S ? S.window(o) : { start: addB(o, min), end: addB(o, max) };
      var html = 'Chega entre <b>' + esc(fmt(w.start)) + '</b> e <b>' + esc(fmt(w.end)) + '</b>.';
      var e = parse(ei.value);
      if (e) {
        var last = null;
        if (S) last = S.latestOrder(e);
        else { var c = new Date(e.getTime()); while (addB(c, max) > e) c.setDate(c.getDate() - 1); last = c < t0 ? null : c; }
        html += last
          ? '<small>Para chegar até ' + esc(fmt(e)) + ', peça até <b>' + esc(fmt(last)) + '</b>.</small>'
          : '<small>Para ' + esc(fmt(e)) + ', o prazo máximo já não alcança. Se a data não pode falhar, fale com a gente antes de comprar.</small>';
      } else {
        html += '<small>' + min + ' a ' + max + ' dias úteis, da compra à entrega.</small>';
      }
      out.innerHTML = html;
    }
    function all() { document.querySelectorAll('[data-sv-ship-calc]').forEach(run); }
    document.addEventListener('input', function (ev) { var b = ev.target.closest && ev.target.closest('[data-sv-ship-calc]'); if (b) run(b); });
    document.addEventListener('change', function (ev) { var b = ev.target.closest && ev.target.closest('[data-sv-ship-calc]'); if (b) run(b); });
    document.addEventListener('shopify:section:load', all);
    document.addEventListener('sv:ready', all);
    if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  })();

  } catch(e) { console.error(e); }
})();
})();
